export default __webpack_public_path__ + "static/media/Screen-Failure.e307d274.svg";